import React from 'react';

const TariffPage = React.lazy(() => import('./TariffPage'));
const BaseTariffPage = React.lazy(() => import('./base-tariff/BaseTariff'));
const DefineTransportPage = React.lazy(() => import('./define-transport/DefineTransport'));
const CreateSaleryPage = React.lazy(() => import('./base-tariff/CreateSaleryPage'));

const TariffConfig = {
  settings: {
    layout: {
      config: {},
    },
  },

  routes: [
    {
      path: 'tariff/base-tariff',
      element: <BaseTariffPage />,
      auth: null,
    },
    {
      path: 'tariff/transport-list',
      element: <TariffPage />,
    },

    {
      path: 'tariff/define-transport',
      element: <DefineTransportPage />,
    },
    {
      path: 'tariff/define-transport/:id',
      element: <DefineTransportPage />,
    },
    {
      path: 'tariff/create-salery/:id',
      element: <CreateSaleryPage />,
      auth: null,
    },
  ],
};

export default TariffConfig;
